/**
 * Returns a mapping used to translate configurations between the front-end and the configuration service.
 * This is essentially the front-end equivalent of TabletAuthenticationOptions.java.
 *
 * The value of this object is to add a bit of protection against changes in the server-side environment.
 *
 * The keys in this must match the validation fields in the handlebars template used by the FormView.
 * The corresponding values should match the values in the enum.
 *
 * @class eregAuthConfigOptions
 * @static
 */
module.exports = {
  /**
   * @property firstName {String}
   * @default 'FIRST_NAME'
   * @static
   */
  firstName: 'FIRST_NAME',
  /**
   * @property lastName {String}
   * @default 'LAST_NAME'
   * @static
   */
  lastName: 'LAST_NAME',
  /**
   * @property dob {String}
   * @default 'DATE_OF_BIRTH'
   * @static
   */
  dob: 'DATE_OF_BIRTH',
  /**
   * @property phone {String}
   * @default 'PHONE'
   * @static
   */
  phone: 'PHONE',
  /**
   * @property patientId {String}
   * @default 'MRN'
   * @static
   */
  patientId: 'MRN',
  /**
   * @property lastFourSsn {String}
   * @default 'LAST_FOUR_SSN'
   * @static
   */
  lastFourSsn: 'LAST_FOUR_SSN'
};
